<template>
    <div>
        <div class="dashboard-slide">
            <div class="splide-cat" id="dashboard-slide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"
                            v-for="(category, k) in categories" :key="k"
                            @click="clickCategory(category)">

                            <div class="category-item">
                                <div class="category">
                                    <div class="category-img">
                                        <img :src="category.image_url"/>
                                    </div>
                                    <div class="category-name"
                                        :class="{'active': categoryActive == category.id}">
                                        {{localeCode === 1054 ? category.name : category.name_en}}
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- <div class="dashboard-pagination-prev">
                <button class="bg-yellow-400 p-2 mr-4" @click="btnPrev()">Prev</button>
            </div> -->
            <div class="dashboard-pagination-next">
                <img @click="btnNext()" src="../../../../assets/new/icon/ic-pagination-next.png"/>
            </div>
        </div>
        <div class="subcat-home" v-if="subCategories.length > 0">
            <div class="title">{{ categorieName }}</div>
            <div class="subcat-list">
                <div v-for="(subcat, k) in subCategories" :key="k"
                    @click="clickSubCategory(subcat)">
                    <div class="subcat-item"
                        :class="{'active': subCategoryActive == subcat.id}">
                        {{localeCode === 1054 ? subcat.name_th : subcat.name_en}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/
import Locale from '@/helper/locale/Locale';

export default {
    name: 'CategorySlider',
    components: {

    },
    props: {
        categorie: Array
    },
    data: function () {
        return {
            localeCode: Locale.getLocaleCode(),

            categories: [],
            slider: null,
            currentSliderIndex: 0,

            categoryActive: null,
            subCategoryActive: null,
            categorieName: '',
            subCategories: [],
        };
    },mounted: function () {

    },
    created: function () {
        this.categories = this.categorie;
        this.setSlider()

        console.log('this.categories', this.categories)
    },
    methods: {
        clickCategory: function (category) {
            this.categorieName = this.localeCode == 1054 ? category.name : category.name_en;
            this.categoryActive = category.id;

            let selectCat = category;
            if(category.subcats.length > 0){
                this.subCategories = category.subcats;
                this.subCategoryActive = category.subcats[0].id;
                selectCat = category.subcats[0];
            }else{
                this.subCategories = [];
            }
            this.$emit('changeCategory', selectCat);
        },
        clickSubCategory: function (subcategory) {
            this.subCategoryActive = subcategory.id;
            this.$emit('changeCategory', subcategory);
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#dashboard-slide', {
                    type : 'slide',
                    autoWidth: true,
                    pagination : false,
                    arrows: false,
                    gap: 15,
                }).mount()

                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex
                })
            })
        },
        btnNext: function() {
            let next = this.currentSliderIndex + 1
            this.slider.go(next)
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1
            this.slider.go(prev)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.dashboard-slide {
    position: relative;
    .category-item {
        width: 100%;
        max-width: 120px;
        cursor: pointer;
        .category-img {
            width: 120px;
            height: 120px;
            border-radius: 10px;
            img {
                border-radius: 10px;
            }
        }
        .category-name {
            text-align: center;
            font-size: $px16;
            color: $a-black-333333;
            margin-top: 10px;

            &.active{
                color: $a-orange-f8a51b;
            }
        }
    }

    // .dashboard-pagination-prev {
    //     position: absolute;
    //     display: flex;
    //     justify-content: start;
    //     top: 60px;
    //     left: -30px;
    //     width: 100%;
    // }
    .dashboard-pagination-next {
        position: absolute;
        top: 30%;
        right: -30px;
    }
}

.subcat-home{
    display: flex;
    align-items: baseline;
    gap: 1.5rem;
    margin-top: 15px;

    .title{
        font-family: $ff-medium;
        font-size: 1rem;
        color: $a-black-333333;
    }

    .subcat-list{
        display: flex;
        gap: 0.5rem;

        .subcat-item{
            background-color: $a-orange-fef2d9;
            border-radius: 8px;
            color: $a-black-333333;
            font-size: 1rem;
            padding: 7px 12px;
            cursor: pointer;

            &.active{
                color: $a-orange-f8a51b;
                border: solid 1px $a-orange-f8a51b;
            }
        }
    }
}
</style>
